export default "__VITE_PUBLIC_ASSET__98e02449__"